import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./BranchBanner.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { Select } from "antd";
import HospitalIcon from "../../../components/UI/HospitalIcon";
import branchesService from "../../../services/branches";
import departmentsService from "../../../services/departments";
import doctorsService from "../../../services/doctors";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { NavigationContext } from "../../../App";
import SearchIcon from "../../../components/UI/SearchIcon";

const { Option } = Select;

const BranchBanner = ({ data, branchData }) => {
  const width = useDeviceWidth();
  const swiperRef = useRef(null); // Create a ref to control the Swiper instance
  console.log("branch banner data", data, branchData);
  const [doctors, setDoctors] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  useEffect(() => {
    setSelectedBranch(branchData?._id);
  }, [branchData]);

  const getDepartments = async (query) => {
    const response = await departmentsService.getAll(query);
    console.log("departments data", response);
    setDepartments(response?.data);
  };

  const getDoctors = async (query) => {
    const response = await doctorsService.getAll(query);
    console.log("doctors data", response);
    setDoctors(response?.data);
  };

  useEffect(() => {
    setSelectedDepartment();
    if (selectedBranch) {
      getDepartments(`?branchId=${selectedBranch}`);
    }
  }, [selectedBranch]);

  useEffect(() => {
    if (selectedDepartment || selectedBranch) {
      setSelectedDoctor();
      let query = "";

      if (selectedDepartment) {
        query += `?departmentId=${selectedDepartment}`;
      }

      if (selectedBranch) {
        query += query
          ? `&branchId=${selectedBranch}`
          : `?branchId=${selectedBranch}`;
      }

      getDoctors(query);
    }
  }, [selectedDepartment, selectedBranch]);

  const infoDiv = (data) => {
    const element = (
      <>
        <h5
          className={classes.bannerTag}
          data-aos="fade-right"
          data-aos-delay="100"
        >
          {branchData?.name}
        </h5>
        <h4
          className={classes.bannerHeading}
          data-aos="fade-right"
          data-aos-delay="100"
        >
          {data?.title}
        </h4>
        <h4
          className={classes.bannerPara}
          data-aos="fade-right"
          data-aos-delay="100"
        >
          {data?.description}
        </h4>
        <div
          className={classes.buttonDiv}
          data-aos="fade-right"
          data-aos-delay="100"
        >
          <button
            className={`${classes.bookOnline} primaryHover`}
            onClick={() => {
              const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              setIsBackNavigation(true);
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              navigate("/consultation");
            }}
          >
            Book Appointment Today
          </button>
          <button
            onClick={() => {
              const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              setIsBackNavigation(true);
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              navigate(`/services`);
            }}
            className={`${classes.exploreButton} primaryHover`}
          >
            Explore Services
          </button>
        </div>
      </>
    );

    return (
      <>
        <div className={classes.infoDiv}>
          <div className={classes.divBackground}>{element}</div>
          {/* {element} */}
        </div>
        <div className={classes.infoDiv}>
          {" "}
          <div className={classes.contentHolder}>{element}</div>
        </div>
      </>
    );
  };

  const onSearch = () => {
    const values = {
      branchId: branchData._id,
      departmentId: selectedDepartment,
      doctorId: selectedDoctor,
    };
    const sendingValues = _.pickBy(values, _.identity);
    const fullparams = new URLSearchParams(); //important
    const filterParams = new URLSearchParams(sendingValues)?.toString();
    //to avoid repeating of filters already present in params
    const filterParamsObj = new URLSearchParams(filterParams);
    for (const [key, value] of filterParamsObj.entries()) {
      if (!fullparams.has(key)) {
        fullparams.set(key, value);
      }
    }
    navigate(`/doctors/?${fullparams.toString()}`);
  };

  const searchInputs = () => {
    return (
      <>
        <Select
          showSearch
          placeholder="Select Expertise"
          onChange={(value) => setSelectedDepartment(value)}
          value={selectedDepartment}
          className="search-select"
          prefix={
            <img
              src="/img/icons/heart-icon.svg"
              alt="Icon"
              style={{ marginTop: "5px", marginRight: "3px" }}
            />
          }
          suffixIcon={
            <img
              src="/img/icons/dropdown-arrow.svg"
              alt="Icon"
              style={{ width: 14, height: 14, marginRight: "10px" }}
            />
          }
        >
          {departments?.map((item) => (
            <Option className="custom-option" value={item?._id}>
              {item?.department_name}
            </Option>
          ))}
        </Select>
        <Select
          showSearch
          onChange={(value) => setSelectedDoctor(value)}
          value={selectedDoctor}
          placeholder="Select Doctor"
          className="search-select"
          prefix={
            <img
              src="/img/icons/doc-icon.svg"
              alt="Icon"
              style={{ marginTop: "5px", marginRight: "3px" }}
            />
          }
          suffixIcon={
            <img
              src="/img/icons/dropdown-arrow.svg"
              alt="Icon"
              style={{ width: 14, height: 14, marginRight: "10px" }}
            />
          }
        >
          {doctors?.map((item) => (
            <Option className="custom-option" value={item?._id}>
              {item?.doctor_name}
            </Option>
          ))}
        </Select>
        <button
          className={`${classes.searchButton} primaryHover`}
          onClick={() => {
            const yPos = window.scrollY;
            setIsBackNavigation(true);
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
            onSearch();
          }}
        >
          {" "}
          {/* <img
            src="/img/icons/search.svg"
            alt="search"
            //   style={{ marginTop: "5px", marginRight: "3px" }}
          /> */}
          <SearchIcon />
          Search
        </button>
      </>
    );
  };

  return (
    <div className={`outer-outer ${classes.outerContainer}`}>
      {/* <h1>Title for this website</h1> */}
      <div style={{ position: "relative", width: "100%", margin: "auto" }}>
        {/* <img
          src="/img/designs/banner-top-dots.svg"
          alt=""
          className={classes.sliderDesign}
        /> */}

        {/* {infoDiv()} */}

        {width > 1200 && (
          <div className={classes.searchDiv}>{searchInputs()}</div>
        )}

        {/* Swiper */}
        <Swiper
          className="banner-swiper branch-banner-swiper"
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1} // Show 3 images at a time
          spaceBetween={20} // Add space between slides
          onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
          pagination={{ clickable: true }} // Enable clickable dots
          loop={true} // Enable infinite looping
          style={{ marginBottom: "-4px" }} // Add space for pagination dots
          draggable={true} // Enable drag/swipe functionality
          autoplay={{
            delay: 4000, // Delay between transitions (in milliseconds)
            disableOnInteraction: false, // Keep autoplay running even after user interaction
          }}
        >
          {data?.listingItems?.map((slide) => (
            <SwiperSlide key={slide.id}>
              {infoDiv(slide)}
              <img
                src={width > 1100 ? slide.webImage : slide.mobileImage}
                // src={image}
                // alt={Slide ${slide.id}}
                alt="banner"
                className={classes.sliderImage}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {width < 1200 && (
        <div className={classes.searchContainer}>{searchInputs()}</div>
      )}
    </div>
  );
};

export default BranchBanner;
